import React from 'react';
import styled from 'styled-components';
import { s } from './AppraisalPrice.styles';

interface Props {
  aTable: any[];
  onClose: () => void;
}

function AppraiscalModal({ aTable, onClose }: Props) {
  const isSubHeader = (text: string) => /^\d+\)/.test(text); // 1), 2) ...
  const isSectionHeader = (text: string) => /^\d+\./.test(text); // 1., 2. ...

  const renderAppraisalContent = (aTable: any[]) => {
    if (!aTable) return null;

    const formatBr = (text: string) => {
      // 의미 없는 문자열 '.', '-', 공백만 → null
      const meaninglessPattern = /^[-.\s]*$/;
      if (typeof text !== 'string') return null;

      // 1) 연속 <br/> 하나로
      let t = text.replace(/(<br\s*\/?>\s*){2,}/g, '<br/>');
      // 2) 태그 안의 <br/> 제거
      t = t.replace(/(<[^<>]*?)<br\s*\/?>([^<>]*?>)/g, '$1$2');
      // 3) <br/> → \n
      t = t.replace(/<br\s*\/?>/g, '\n');
      return t;
    };

    return aTable.map((item: any, index: number, array: any[]) => {
      try {
        if (typeof item !== 'string') {
          throw new Error(
            `Invalid item type at index ${index}: ${typeof item}`,
          );
        }

        const text = formatBr(item);
        if (text == null) return null;

        const next =
          typeof array[index + 1] === 'string'
            ? formatBr(array[index + 1])
            : null;
        const meaninglessNext = next == null;

        // 다음 항목이 의미 없으면 헤더도 출력하지 않음
        if ((isSectionHeader(item) || isSubHeader(item)) && meaninglessNext)
          return null;

        if (isSectionHeader(item)) {
          return <s.SectionHeader key={index}>{text}</s.SectionHeader>;
        }
        if (isSubHeader(item)) {
          return <s.SubHeader key={index}>{text}</s.SubHeader>;
        }
        return <s.ContentDescrip key={index}>{text}</s.ContentDescrip>;
      } catch (error) {
        console.error(`Error processing item at index ${index}:`, error);
        return <s.ContentDescrip key={index}>{String(item)}</s.ContentDescrip>;
      }
    });
  };

  return (
    <Container>
      <Header>
        <Icon onClick={onClose}>
          <img src="/assets/images/close/close_black-big.svg" alt="" />
        </Icon>
        <HeaderTitle>감정평가서 요약</HeaderTitle>
        <Icon />
      </Header>
      <Content>
        <Inner>{renderAppraisalContent(aTable)}</Inner>
        <BackButtonContainer>
          <Divider />
          <BackButton onClick={onClose}>상세페이지로 돌아가기 {'>'}</BackButton>
          <Divider />
        </BackButtonContainer>
      </Content>
    </Container>
  );
}

export default AppraiscalModal;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom-width: 1px;
  padding: 6px;
`;

const Icon = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
`;

const Content = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Inner = styled.div`
  background: #f7f8fc;
  width: 100%;
  gap: 8px;
  border-radius: 16px;
  padding: 16px;
`;

const BackButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #f7f7f9;
`;

const BackButton = styled.button`
  border-radius: 9999px;
  padding: 8px 20px;
  background: #f7f7f9;
  border: none;
  white-space: nowrap;

  font-weight: 500;
  font-size: 12px;
  color: #4e5968;
`;
